import { useState } from "react";
import tabletrans from "../../translate/tables";
import CommentsTableRow from "./CommentsTableRow";

function CommentsTable(props) {
  const content = props.content;
  const lang = props.lang;
  const [detail, showDetail] = useState(-1);
  return (
    <table>
      <thead>
        <tr>
          <th>
            <p> محصول</p>
            <i></i>
          </th>
          <th>
            <p> مشتری</p>
            <i></i>
          </th>
          <th>
            <p>کامنت</p>
            <i></i>
          </th>
          <th>
            <p>وضعیت</p>
            <i></i>
          </th>

          <th></th>
        </tr>
      </thead>
      <tbody>
        {content && content
          ? content.map((slider, i) => (
              <CommentsTableRow
                detail={detail}
                showDetail={showDetail}
                item={slider}
                index={i}
                key={i}
                lang={lang}
              />
            ))
          : ""}
      </tbody>
    </table>
  );
}
export default CommentsTable;
